/* eslint-disable max-len */
import axios from 'axios';
import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import RootState from '@store/state';
import {
    SET_INIT_META_DATA,
    SET_INIT_DATA,
    SET_LOCAL_LANG,
    SET_DOM_READY_SCRIPT
} from './type';

import InitDataState from './state';
// import CdnRetryScript from './CdnRetryScript';
import CdnRetryConfig from './CdnRetryConfig';
import CdnRetryConfigIncentive from './CdnRetryConfigIncentive';

axios.defaults.baseURL = '/';
axios.defaults.timeout = 15000;
axios.defaults.xsrfHeaderName = 'x-csrf-token';
axios.defaults.xsrfCookieName = 'csrfToken';

export default class VideoModule implements Module<InitDataState, RootState> {
    state: InitDataState;

    getters: GetterTree<InitDataState, RootState> = {
        initMetaData(state): String {
            return state.initMetaData || '';
        },
        initData(state): Record<string, any> {
            return state.initData || {};
        },
        localLang(state): Record<string, any> {
            return state.localLang || {};
        },
    };

    actions: ActionTree<InitDataState, RootState> = {
        async getInitMetaData({ commit, dispatch, state, rootState }) {
            const cdnRetryScript = rootState?.initData?.cdnRetryScript;
            delete rootState?.initData?.cdnRetryScript;
            
            const pageName: string = rootState?.pageName ?? '';
            const pageType: string = rootState?.pageType ?? '';
            const title: string = rootState?.initData?.title ?? '';
            const opengraph: string = rootState?.opengraph ?? '';
            const message = rootState?.message || { 'video-share': {} };
            const themeColor = rootState?.initData?.themeColor ?? '';
            const imgPath = '//cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/kos/nlav10586/kwai-share/v1/public/asset/images';
            let icon_image = `${imgPath}/kwai_icon_new.ico`;
            const kpn = (rootState?.initData?.kpn || 'KWAI').toUpperCase();
            const initKpn = message?.kpn || {};
            switch (kpn) {
                case initKpn['kwai.me'] || 'KWAI.ME':
                    icon_image = `${imgPath}/kwai_icon_new.ico`;
                    break;
                case initKpn.snack || 'KWAI_BULLDOG':
                    icon_image = `${imgPath}/snack_favicon.ico`;
                    break;
                default:
            };
            const metaString = `
                <title>${title}</title>
                <meta charset="utf-8">
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                <meta name="viewport"
                content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover" />
                <meta name="format-detection" content="telephone=no">
                ${themeColor ? `<meta name="theme-color" content="${themeColor}" />` : ''}
                <meta http-equiv="x-dns-prefetch-control" content="on" />
                <link rel="shortcut icon" type="image/ico" href="${icon_image}">
                <link rel="preconnect" href="//logsdk.kwai-pro.com" crossorigin>
                <link rel="preconnect" href="//cdn-static.kwai.net" crossorigin>
                <link rel="preconnect" href="//ak-br-pic.kwai.net" crossorigin>
                <link rel="preconnect" href="//aws-pic.kwai.net" crossorigin>
                <link rel="preconnect" href="//ak-cdn.kwai.net" crossorigin>
                <link rel="dns-prefetch" href="//logsdk.kwai-pro.com">
                <link rel="dns-prefetch" href="//cdn-static.kwai.net">
                <link rel="dns-prefetch" href="//ak-br-pic.kwai.net">
                <link rel="dns-prefetch" href="//aws-pic.kwai.net">
                <link rel="dns-prefetch" href="//ak-cdn.kwai.net">
            `;
            const videoMetaString = `
                <link rel="preconnect" href="https://aws-br-cdn.kwai.net" crossorigin>
                <link rel="preconnect" href="http://aws-br-cdn.kwai.net" crossorigin>
                <link rel="preconnect" href="https://aws-br-pic.kwai.net" crossorigin>
                <link rel="preconnect" href="http://aws-br-pic.kwai.net" crossorigin>
                <link rel="dns-prefetch" href="https://aws-br-pic.kwai.net">
                <link rel="dns-prefetch" href="http://aws-br-pic.kwai.net">
                <link rel="dns-prefetch" href="https://aws-br-cdn.kwai.net">
                <link rel="dns-prefetch" href="http://aws-br-cdn.kwai.net">
            `;

            const scriptString = `
                <script>(function(){try {${cdnRetryScript};if (typeof window.KibtLog === 'function') {window.__kibtlog__ = new window.KibtLog(${ JSON.stringify(pageType === 'incentive' ? CdnRetryConfigIncentive : CdnRetryConfig) });}} catch(e) {setTimeout(function() {throw 'kibt-log error: '+e;});}})()</script>
            `;
            const fmpUpload = `<script>
                if (window 
                    && window.__kibtlog__
                    && window.__kibtlog__.logger
                    && window.__kibtlog__.logger.reportData
                    && window.__kibtlog__.logger.sepDimension) {

                    const getNowTimestamp = function() {return new Date().getTime();}

                    const getNavigationStart = function() {
                        if (window.performance
                            && window.performance.timing
                            && window.performance.timing.navigationStart) {
                                return window.performance.timing.navigationStart
                            }
                        return null;
                    };

                    const ngStart = getNavigationStart();

                    if (!!ngStart) {
                        const ssrfmp = getNowTimestamp() - ngStart;
                        window.performance.timing.ssr_fmp = ssrfmp;
                        window.__kibtlog__.logger.reportData(
                            window.__kibtlog__.logger.sepDimension({
                                key: 'event',
                                value: {
                                    name: 'ssrFmp',
                                    event_type: 'detect',
                                    duration: ssrfmp,
                                },
                            })
                        );
                    }
                }</script>
            `;
            const checkCDNScriptString = `
                <script>
                ;window.addEventListener('load', function() {
                    if (Math.random() > 0.1||(document.cookie || '').indexOf('1627985338192=1') > -1) {
                    return;
                    }
                    document.cookie = '1627985338192=1; path=/; max-age=3600';
                    var date = new Date();
                    var now = date.getTime();
                    var urls = [
                    'https://aws-static.kwai.net/udata/pkg/proweb/cdntest/13.png',
                    'https://ak-static.kwai.net/udata/pkg/proweb/cdntest/13.png',
                    'https://cdn-static.ap4r.com/kos/s101/nlav11312/other/cdntest/13.png',
                    'https://cdn-static.kwai.net/kos/s101/nlav11312/other/cdntest/13.png'
                    ];
                    for (var l = urls.length; l--;){
                    var url = urls.splice(Math.floor(Math.random() * urls.length), 1)[0];
                    setTimeout(function(url) {
                        var link = document.createElement('link');
                        link.rel = 'preload';
                        link.href= url+'?_v=' + now;
                        link.as ='image';
                        document.body.appendChild(link);
                    }, l * 1000 + 2000, url);
                    }
                });
                </script>`;

            

            let metaMeta = `${metaString}${opengraph}`;

            if (pageName === 'photo') {
                const href = rootState?.origin + rootState?.url;
                let structuredDataText = `<script data-assets-retry-hooked="true" type="application/ld+json">{
                "@context": "https://schema.org",
                "@type": "VideoObject",
                "name": "${encodeURIComponent(rootState?.initData?.title || '')}",
                "description": "${encodeURIComponent(rootState?.initData?.description || '')}",
                "contentUrl": "${rootState?.initData?.mp4Url || ''}",
                "uploadDate": "${rootState?.initData?.uploadDate || ''}",
                "interactionStatistic": {
                  "@type": "InteractionCounter",
                  "interactionType": { "@type": "https://schema.org/WatchAction" },
                  "userInteractionCount": 20000
                },
                "thumbnailUrl": "${href}"
              }</script>`;
                if (rootState?.initData?.regionsAllowed && rootState?.initData?.regionsAllowed.length) {
                    structuredDataText = `<script data-assets-retry-hooked="true" type="application/ld+json">{
                    "@context": "https://schema.org",
                    "@type": "VideoObject",
                    "name": "${encodeURIComponent(rootState?.initData?.title || '')}",
                    "description": "${encodeURIComponent(rootState?.initData?.description || '')}",
                    "contentUrl": "${rootState?.initData?.mp4Url || ''}",
                    "uploadDate": "${rootState?.initData?.uploadDate || ''}",
                    "thumbnailUrl": "${href}",
                    "interactionStatistic": {
                      "@type": "InteractionCounter",
                      "interactionType": { "@type": "https://schema.org/WatchAction" },
                      "userInteractionCount": 20000
                    },
                    "regionsAllowed": "${rootState?.initData?.regionsAllowed.join(',')}"
                  }</script>`;
                }
                metaMeta = `${metaMeta}${videoMetaString}${structuredDataText}`;
            }

            metaMeta = `${metaMeta}${scriptString}${fmpUpload}${checkCDNScriptString}`;

            const initMetaData: string = metaMeta;
            commit(SET_INIT_META_DATA, initMetaData);
        },
        async getInitData({ commit, dispatch, state, rootState }) {
            const origin = rootState?.origin || '';
            const url = rootState?.url || '/';
            const href = `${origin}${url}`;
            const initData = rootState?.initData || {};
            const locale = rootState?.locale || '';
            const message = rootState?.message || {};
            commit(SET_INIT_DATA, { ...initData, href, locale, message });
        },
        async getLocalLang({ commit, dispatch, state, rootState }) {
            const localLang = rootState?.message?.localLang || {};
            commit(SET_LOCAL_LANG, localLang);
        },
    };

    mutations: MutationTree<InitDataState> = {
        [SET_INIT_META_DATA](state, data) {
            state.initMetaData = data;
        },
        [SET_INIT_DATA](state, data) {
            state.initData = data;
        },
        [SET_LOCAL_LANG](state, data) {
            state.localLang = data;
        },
    };

    constructor(initState: InitDataState) {
        this.state = {
            initMetaData: '',
            initData: {},
            localLang: {},
            ...initState,
        };
    }

}

